import React, { useCallback, useEffect, useMemo, useState } from 'react'
import { assigncurriculumProps } from './assigncurriculum-interface'
import { Alert, Button, Form, Modal, Radio, Select } from 'antd'
import { useSelector } from 'react-redux'
import { RootState } from '../../../../../../store/store'
import { openNotificationWithIcon } from '../../../../../../utils/helper'
import { assignCurriculumToClass, getCurriculums } from '../../../../../../api/curriculum/curriculum'

const { Option } = Select

const curriculaTypes = ["Your Curriculum", "From Codefunhouse"]
const selectionTypes = ["All students", "Some students"]

const Assigncurriculum = ({ open, closeModal, students, classId }: assigncurriculumProps) => {
	const [form] = Form.useForm();

	const [loadingCurriculum, setLoadingCurriculum] = useState(false)
	const [data, setData] = useState([])
	const [currentType, setCurrentType] = useState(null)
	const [selectionType, setSelectionType] = useState(null)
	const [error, setError] = useState<any>(null)
	const [loading, setLoading] = useState(false)
	const [errors, setErrors] = useState({
		currentType: "",
		curriculumId: "",
		assignTo: "",
		assigneeIds: ""
	})


	const state = useSelector((state: RootState) => ({
		user: state.user.user,
	}))

	const { user } = state

	const requestParams = useMemo(() => {
		return {
			createdBy: currentType === curriculaTypes[0] ? user?._id : undefined
		}

		// eslint-disable-next-line
	}, [currentType])

	const fetchCurriculums = useCallback(
		async () => {
			if (currentType !== null) {
				try {
					setLoadingCurriculum(true)
					const res = await getCurriculums(requestParams)
					const { data } = res?.data
					setData(data)
					setLoadingCurriculum(false)
				} catch (error: any) {
					setLoadingCurriculum(false)
					if (error?.response) {
						openNotificationWithIcon('error', 'Get Curriculums', `${error?.response?.data?.message || 'Something went wrong'}`)
					} else {
						openNotificationWithIcon('error', 'Get Curriculums', 'Something went wrong')
					}
				}
			}
		},
		[requestParams, currentType],
	)

	useEffect(() => {
		fetchCurriculums()

	}, [fetchCurriculums])


	const onFinish = async (values: any) => {
		try {
			setError(null)
			setLoading(true)
			const { curriculumId, assigneeIds, assignTo } = values

			const studentsIds = students.map((item) => item._id)

			const data: any = {
				curriculumId,
				classId,
				assignerId: user?._id,
				assigneeIds: assignTo === selectionTypes[0] ? studentsIds : assigneeIds
			}

			const res = await assignCurriculumToClass({ ...data })

			const { message } = res.data

			openNotificationWithIcon("success", "Assign Curriculum", message || 'Curriculum assigned successfully')

			setLoading(false)
			closeModal(true)

		} catch (error: any) {
			setLoading(false)
			const otherErrors: any[] = []
			if (error?.response) {
				if (error?.response?.data?.errors) {
					const resError = error?.response?.data?.errors

					Object.entries(resError).forEach(([key, value]) => {
						if (Object.keys(errors).includes(key)) {
							setErrors(prevState => ({
								...prevState,
								[key]: value
							}))
						} else {
							otherErrors.push(value)
						}
					})

					if (otherErrors.length > 0) {
						const errorList = otherErrors.map((element: any, index) => {
							return <li key={`error-list-${index}`}>{element}</li>
						});
						setError(errorList)
					}

				} else {
					setError(error?.response?.data?.message || 'Something went wrong')
				}
			} else {
				setError('Something went wrong')
			}
		}
	}

	return (
		<div>
			<Modal
				closable={false}
				open={open}
				onOk={() => {
					if (!loading) {
						closeModal()
					}
				}}
				onCancel={() => {
					if (!loading) {
						closeModal()
					}
				}}
				footer={null}
				width={'38rem'}
				className='white-bg-modal'
			>
				<div>
					<div className='flex border-b border-appcolorgreyfour pb-[0.75rem] justify-between items-center'>
						<h1 className='text-[22px] leading-[110%] font-semibold text-appcolorgrey mb-[-1rem]'>Assign Curriculum</h1>
						<div className='rounded-full bg-appcolorgreyfive custom-box-shadow-five p-[0.9rem] w-fit cursor-pointer'
							onClick={() => {
								if (!loading) {
									closeModal()
								}
							}}
						>
							<img src="/img/vectors/modalclose.svg" alt="" />
						</div>
					</div>

					<div className='mt-[2rem]'>
						{
							error !== null ?
								<div className='mb-4'>
									<Alert message={error} type="error" />
								</div>
								: null
						}

						<Form
							layout="vertical"
							onFinish={onFinish}
							form={form}
						>
							<div id="select-curriculum-type-area">
								<Form.Item
									label="Curriculum Type"
									name="currentType"
									rules={[{ required: true, message: 'Input is required' }]}
									validateStatus={errors?.currentType.length > 0 ? 'error' : undefined}
									help={errors?.currentType.length > 0 ? errors?.currentType : undefined}
								>
									<Select
										placeholder="Pick curriculum from"
										loading={false}
										//@ts-ignore
										getPopupContainer={() => document.getElementById('select-curriculum-type-area')}
										className='capitalize'
										onSelect={(value) => {
											setCurrentType(value);
										}}
									>
										{
											curriculaTypes.map((item: any) => (
												<Option
													key={item}
													value={item} className="capitalize"
												>
													{item}
												</Option>
											))
										}
									</Select>
								</Form.Item>
							</div>

							{
								currentType !== null ?
									<>
										<div id="select-curriculum-area">
											<Form.Item
												label="Curriculum"
												name="curriculumId"
												rules={[{ required: true, message: 'Input is required' }]}
												validateStatus={errors?.curriculumId.length > 0 ? 'error' : undefined}
												help={errors?.curriculumId.length > 0 ? errors?.curriculumId : undefined}
											>
												<Select
													placeholder="What curriculum would you be teaching? "
													loading={loadingCurriculum}
													//@ts-ignore
													getPopupContainer={() => document.getElementById('select-language-area')}
													className='capitalize'
												>
													{
														data.map((item: any) => (
															<Option
																key={item?._id}
																value={item?._id} className="capitalize"
															>
																{item.name}
															</Option>
														))
													}
												</Select>
											</Form.Item>
										</div>

										<Form.Item
											label="Assign Curriculum to"
											name="assignTo"
											rules={[{ required: true, message: 'Input is required' }]}
											validateStatus={errors?.assignTo.length > 0 ? 'error' : undefined}
											help={errors?.assignTo.length > 0 ? errors?.assignTo : undefined}
										>
											<Radio.Group
												onChange={(e) => {
													setSelectionType(e.target.value)
												}}
											>
												{
													selectionTypes.map((item, index) => (
														<Radio value={item} key={`selctiontype-${index}`}> {item} </Radio>
													))
												}

											</Radio.Group>
										</Form.Item>

										{
											selectionType === selectionTypes[1] ?
												<div id="select-assigneeIds-area">
													<Form.Item
														name="assigneeIds"
														label="Select Students"
														rules={[{ required: true, message: 'Input is required' }]}
														validateStatus={errors?.assigneeIds.length > 0 ? 'error' : undefined}
														help={errors?.assigneeIds.length > 0 ? errors?.assigneeIds : undefined}
													>
														<Select
															mode="multiple"
															placeholder="Select multiple students"
															className='w-full capitalize'
															//@ts-ignore
															getPopupContainer={() => document.getElementById('select-assigneeIds-area')}
														>
															{
																students.map((item: any) => (
																	<Option key={item._id} value={item?._id}>
																		{`${item.firstName} ${item.lastName}`}
																	</Option>
																))
															}
														</Select>
													</Form.Item>
												</div> :
												null
										}
									</>
									:
									null
							}

							<div className='mt-[2.5rem] flex justify-end'>
								<Button
									onClick={() => {
										if (!loading) {
											closeModal()
										}
									}}
									style={{
										color: '#200E32 !important'
									}}
									disabled={loading}
									className='mr-[0.9rem] custom-white-btn black-text smaller-padding'>

									Cancel
								</Button>

								<Button
									disabled={loading}
									className='custom-primary-two-btn smaller-padding'
									loading={loading}
									htmlType='submit'
								>
									Submit
								</Button>
							</div>
						</Form>
					</div>
				</div>
			</Modal>
		</div>
	)
}

export default Assigncurriculum